import React from 'react'
import ClaimedSvg from '../../../components/svgComponents/ClaimedSvg'
import MiningSvg from '../../../components/svgComponents/MiningSvg'
import ReferralsSvg from '../../../components/svgComponents/ReferralsSvg'
import ClaimAnalytic from './ClaimAnalytic'
import StatisticItem from './StatisticItem'
import { useTokensStore } from '../../../store/tokensStore'

const Analytics = ({
  claimedRewards,
  earnedRewards,
  totalReferralAmount,
  handleClaimXbrRewards,
  selectedCard,
  isVerifying,
}) => {
  const { xbrPrice } = useTokensStore()
  const totalClaimedUsdt = (value) => {
    return value === 0 ? 0 : (value * xbrPrice).toFixed(2)
  }

  return (
    <section className='grid gap-4 md:grid-cols-2 xl:grid-cols-4 xl:h-[228px] mb-8 w-full'>
      <StatisticItem
        statisticIcon={<ClaimedSvg />}
        statisticLabel={'Claimed'}
        statisticDescription={'Total rewards claimed already'}
        totalClaimed={
          isNaN(Number.parseFloat(claimedRewards).toFixed(2))
            ? Number.parseFloat(0).toFixed(2)
            : Number.parseFloat(claimedRewards).toFixed(2)
        }
        totalUsdt={
          isNaN(totalClaimedUsdt(claimedRewards))
            ? totalClaimedUsdt(0)
            : totalClaimedUsdt(claimedRewards)
        }
      />
      <StatisticItem
        statisticIcon={<MiningSvg />}
        statisticLabel={'Mining'}
        statisticDescription={'Estimated Mining Rewards'}
        totalClaimed={
          isNaN(Number.parseFloat(earnedRewards).toFixed(2))
            ? Number.parseFloat(0).toFixed(2)
            : Number.parseFloat(earnedRewards).toFixed(2)
        }
        totalUsdt={
          isNaN(totalClaimedUsdt(earnedRewards))
            ? totalClaimedUsdt(0)
            : totalClaimedUsdt(earnedRewards)
        }
      />
      <StatisticItem
        statisticIcon={<ReferralsSvg />}
        statisticLabel={'Referrals'}
        statisticDescription={'Rewards from Referrals'}
        totalClaimed={
          isNaN(Number.parseFloat(totalReferralAmount).toFixed(2))
            ? Number.parseFloat(0).toFixed(2)
            : Number.parseFloat(totalReferralAmount).toFixed(2)
        }
        totalUsdt={
          isNaN(totalClaimedUsdt(totalReferralAmount))
            ? totalClaimedUsdt(0)
            : totalClaimedUsdt(totalReferralAmount)
        }
      />
      <ClaimAnalytic
        selectedNode={selectedCard}
        xbrPrice={xbrPrice}
        handleClaimXbrRewards={handleClaimXbrRewards}
        isVerifying={isVerifying}
      />
    </section>
  )
}

export default Analytics
